export const isFilledWord = ({ word }: { word: { [key: string]: string } }) => {
  const hasProps = Object.values(word).filter(word => word).length;
  return hasProps;
};

export const isFilledSound = ({ name }: { name: { [key: string]: string } }) => {
  const hasProps = Object.values(name).filter(name => name).length;
  return hasProps;
};
